import React, { forwardRef } from 'react'
import * as Styled from './styled'
import MediaControlItem from './MediaControlItem'
import { useMediaControls } from './useMediaControlItems'
import { translate } from 'utils/translations'

export interface IMediaControlsProps {
  onOpenZOrderMenuFromToolbar?: (position: { x: number; y: number }) => void
}

export const MediaControls = forwardRef<HTMLDivElement, IMediaControlsProps>(
  (props, ref) => {
    const { onOpenZOrderMenuFromToolbar } = props
    const { mediaControls } = useMediaControls({
      onOpenZOrderMenuFromToolbar
    })

    return (
      <Styled.MediaControls ref={ref}>
        {mediaControls.map(mediaControl => (
          <React.Fragment key={mediaControl.id}>
            {mediaControl.type === 'divider' ? (
              <Styled.MediaControlDivider />
            ) : (
              <MediaControlItem
                icon={mediaControl.icon}
                onClick={mediaControl.onClick || (() => {})}
                disabled={mediaControl.disabled}
                tooltipText={
                  mediaControl.tooltipText
                    ? translate(mediaControl.tooltipText)
                    : ''
                }
              />
            )}
          </React.Fragment>
        ))}
      </Styled.MediaControls>
    )
  }
)

MediaControls.displayName = 'MediaControls'

export default MediaControls
